import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import type { components } from "../api/types";

export type User = components["schemas"]["User"];

// useUser fetches GET /api/v1/me and treats 401 as "not logged in"
// (returns null), distinct from a real network/server error which
// throws. Same semantics as the user app's useUser; the admin app
// also relies on this for the is_admin gate in RequireAuth.
export function useUser() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<User | null> => {
      const { data, error, response } = await apiClient.GET("/api/v1/me");
      if (error) {
        if (response.status === 401) return null;
        throw error;
      }
      return data ?? null;
    },
    retry: false,
    staleTime: 30_000,
  });
}
